<template>
  <transition
    :name="transition"
    @before-enter="beforeEnter"
    @after-enter="afterEnter"
    @after-leave="afterLeave"
  >
    <div
      v-show="visible"
      class="el-dialog__wrapper"
      @mousedown="handleWrapperMousedown"
      @mouseup="handleWrapperMouseup"
      @click.self="handleWrapperClick"
    >
      <div
        :key="key"
        ref="dialog"
        role="dialog"
        aria-modal="true"
        :aria-label="title || 'dialog'"
        :class="[
          'el-dialog',
          {
            'is-fullscreen': fullscreen,
            'el-dialog--center': center,
            [`bg-${$attrs['bg-color']}`]: $attrs['bg-color']
          },
          customClass
        ]"
        :style="style"
      >
        <div
          :class="[
            'el-dialog__header',
            { [`bg-${$attrs['header-bg-color']}`]: $attrs['header-bg-color'] }
          ]"
        >
          <slot name="title">
            <span class="el-dialog__title">{{ title }}</span>
          </slot>
          <button
            v-if="showClose"
            type="button"
            class="el-dialog__headerbtn"
            aria-label="Close"
            @click="handleClose"
          >
            <i class="el-dialog__close el-icon el-icon-close"></i>
          </button>
        </div>
        <div
          v-if="rendered"
          :class="[
            'el-dialog__body',
            { [`bg-${$attrs['body-bg-color']}`]: $attrs['body-bg-color'] }
          ]"
        >
          <slot></slot>
        </div>
        <div
          v-if="$slots.footer"
          :class="[
            'el-dialog__footer',
            { [`bg-${$attrs['footer-bg-color']}`]: $attrs['footer-bg-color'] }
          ]"
        >
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import Popup from 'element-ui/lib/utils/popup';
import Migrating from 'element-ui/lib/mixins/migrating';
import emitter from 'element-ui/lib/mixins/emitter';

export default {
  name: 'ElDialog',

  mixins: [Popup, emitter, Migrating],

  props: {
    title: {
      type: String,
      default: ''
    },

    modal: {
      type: Boolean,
      default: true
    },

    modalAppendToBody: {
      type: Boolean,
      default: true
    },

    appendToBody: {
      type: Boolean,
      default: true
    },

    lockScroll: {
      type: Boolean,
      default: true
    },

    closeOnClickModal: {
      type: Boolean,
      default: true
    },

    closeOnPressEscape: {
      type: Boolean,
      default: true
    },

    showClose: {
      type: Boolean,
      default: true
    },

    width: String,
    height: String,

    fullscreen: Boolean,

    customClass: {
      type: String,
      default: ''
    },

    top: {
      type: String,
      default: ''
    },
    beforeClose: Function,
    center: {
      type: Boolean,
      default: false
    },

    destroyOnClose: {
      type: Boolean,
      default: true
    },

    transition: {
      type: String,
      default: 'rt-zoom-target'
    }
  },

  data () {
    return {
      closed: false,
      key: 0,
      mousedownTargetInDialog: false
    };
  },

  computed: {
    style () {
      let style = {};
      if (!this.fullscreen) {
        style.marginTop = this.top;
        if (this.width) {
          style.width = this.width;
        }
        if (this.height) {
          style.height = this.height;
        }
      }
      return style;
    }
  },

  watch: {
    visible (val) {
      if (val) {
        if (this._nextVisibleChangeKey) {
          this.key++;
          this._nextVisibleChangeKey = false;
        }
        this.closed = false;
        this.$emit('open');
        this.$el.addEventListener('scroll', this.updatePopper);
        this.$nextTick(() => {
          this.$refs.dialog.scrollTop = 0;
        });
        if (this.appendToBody) {
          document.body.appendChild(this.$el);
        }
      } else {
        this.$el.removeEventListener('scroll', this.updatePopper);
        if (!this.closed) this.$emit('close');
        if (this.destroyOnClose) {
          this.$nextTick(() => {
            this._nextVisibleChangeKey = true;
          });
        }
      }
    }
  },

  mounted () {
    if (this.visible) {
      this.rendered = true;
      this.open();
      if (this.appendToBody) {
        document.body.appendChild(this.$el);
      }
    }
  },

  destroyed () {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  },

  methods: {
    getMigratingConfig () {
      return {
        props: {
          size: 'size is removed.'
        }
      };
    },
    handleWrapperClick () {
      if (!this.closeOnClickModal || this._mousedownTargetInDialog || this._mouseupTargetInDialog) return;
      this.handleClose();
    },
    handleWrapperMousedown (e) {
      this._mousedownTargetInDialog = this.$refs.dialog.contains(e.target) || this.$refs.dialog === e.target;
    },
    handleWrapperMouseup (e) {
      this._mouseupTargetInDialog = this.$refs.dialog.contains(e.target) || this.$refs.dialog === e.target;
    },
    handleClose () {
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide);
      } else {
        this.hide();
      }
    },
    hide (cancel) {
      if (cancel !== false) {
        this.$emit('update:visible', false);
        this.$emit('close');
        this.closed = true;
      }
    },
    updatePopper () {
      this.broadcast('ElSelectDropdown', 'updatePopper');
      this.broadcast('ElDropdownMenu', 'updatePopper');
    },
    beforeEnter () {
      if (this.$el && this.transition === 'rt-zoom-target') {
        const x = window.event ? window.event.x + 'px' : '50%';
        const y = window.event ? window.event.y + 'px' : '50%';
        this.$el.style['transform-origin'] = `${x} ${y}`;
      }
    },
    afterEnter () {
      this.$emit('opened');
    },
    afterLeave () {
      this.$emit('closed');
    }
  }
};
</script>



// WEBPACK FOOTER //
// component.vue?467774ec